
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 7.091C1.416 3.5 4.91.955 9 .955c4.091 0 7.585 2.545 9 6.136-1.415 3.592-4.909 6.137-9 6.137-4.09 0-7.584-2.545-9-6.137zm16.216 0A7.994 7.994 0 009 2.592a7.994 7.994 0 00-7.216 4.5A7.994 7.994 0 009 11.592c3.1 0 5.866-1.742 7.216-4.5zM9 5.047a2.046 2.046 0 11-.002 4.092A2.046 2.046 0 019 5.046zM5.318 7.09A3.687 3.687 0 019 3.41a3.687 3.687 0 013.682 3.681A3.687 3.687 0 019 10.774a3.687 3.687 0 01-3.682-3.681z","fill":"#C4C4C4"}})])
          )
        }
      }
    